import React from "react";

function TourCancellation() {
  return <div>TourCancellation</div>;
}

export default TourCancellation;
